import { Link } from 'react-router-dom';
import { siteInfo, comics } from '@/mocks/comics';

export default function StatsBanner() {
  const newToday = comics.slice(0, 3).map((c) => c.title).join('、');

  return (
    <section className="py-12 px-4 md:px-6 bg-primary-500" aria-label="平台数据">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1">{siteInfo.stats.totalComics}</div>
            <p className="text-sm text-white/70">漫画资源</p>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1">{siteInfo.stats.dailyReaders}</div>
            <p className="text-sm text-white/70">日活跃读者</p>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1">{siteInfo.stats.monthlyUpdates}</div>
            <p className="text-sm text-white/70">月更新章节</p>
          </div>
          <div className="text-center">
            <div className="text-3xl md:text-4xl font-bold text-white mb-1">{siteInfo.stats.satisfaction}</div>
            <p className="text-sm text-white/70">用户好评率</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-white/80 text-sm">
            <i className="ri-flashlight-line mr-1"></i>
            今日更新：<strong className="text-white">{newToday}</strong> 等热门韩漫
          </p>
        </div>
      </div>
    </section>
  );
}